import { Bench } from '~/components/Landing/Bench'

export default function BenchPage() {
  return <Bench />
}